/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_1_5 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [-3.1746715019939797, 55.951276793501364],
                        [-3.2117503594158547, 55.951276793501364],
                        [-3.2117503594158547, 55.933684153859936],
                        [-3.1746715019939797, 55.933684153859936],
                        [-3.1746715019939797, 55.951276793501364]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_1_5